interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): (number | "ellipsis")[] {
  const pages: (number | "ellipsis")[] = [];
  const push = (p: number | "ellipsis") => {
    if (!pages.includes(p)) pages.push(p);
  };
  push(1);
  if (page > 3) push("ellipsis");
  for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i += 1) push(i);
  if (page < totalPages - 2) push("ellipsis");
  if (totalPages > 1) push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 pt-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
        上一页
      </button>

      {pages.map((item, index) =>
        item === "ellipsis" ? (
          <span key={`e-${index}`} className="px-1 text-foreground-400">
            …
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`h-9 w-9 rounded-md border text-sm transition-colors whitespace-nowrap ${
              item === page
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {item}
          </button>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
      </button>
    </div>
  );
}